import Right from './Right'

function IncreasePrecision(props){
    
    return (<>
        <div style={{fontSize:'12px', width:'23px', marginLeft:'5px', padding:'2px', fontWeight:'normal', border:'0.5px solid var(--aixelo-gray-light)', borderRadius:'5px'}}>
            <div style={{position:'relative', zIndex:'10',display:'flex', alignItems:'center', flexDirection:'row', fontSize:'12px', fontWeight:'normal'}}>
                <Right id={props.id} active={true} handleClick={props.handleClick}/> <div style={{margin:'0px', padding:'0px'}}>.0</div>
            </div>
            <div style={{margin:'0px', padding:'0px', marginLeft:'3px'}}>
                .00
            </div>
        </div>
    </>);
}
    

export default IncreasePrecision